export default __webpack_public_path__ + "static/media/agendado.53f3b7a8.svg";